import React from "react";
import { createPortal } from "react-dom";
import ModalHeader from "./ModalHeader";
import styles from "./WorkoutRationaleModal.module.css";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { useScrollFade } from "../hooks/useScrollFade";

function formatRationale(text) {
  if (!text) return null;
  return text.split(/\n+/).filter(Boolean).map((line, i) => {
    const trimmed = line.trim();
    const isHeading = trimmed.endsWith(":") || /^[\u{1F300}-\u{1FAFF}]/u.test(trimmed);
    if (isHeading) {
      return <p key={i} className={styles.heading}>{trimmed}</p>;
    }
    return <p key={i} className={styles.text}>{trimmed}</p>;
  });
}

export default function WorkoutRationaleModal({ rationale, onClose, professorLogoUrl }) {
  useBodyScrollLock();
  const { scrollRef, canScrollMore, check } = useScrollFade();
  if (!rationale) return null;

  const content = (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <ModalHeader
          title="Explicação do treino"
          onClose={onClose}
          logoUrl={professorLogoUrl}
        />
        <div className={styles.body} ref={scrollRef} onScroll={check}>
          {formatRationale(rationale)}
          {canScrollMore && <div className={styles.scrollFade} aria-hidden="true" />}
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
